import React from 'react';
import { Container, Typography, Card, CardContent } from '@mui/material';

const SettingsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Platform configuration and preferences
      </Typography>

      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Platform Settings
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Configuration options for the Studio Sivad Management Platform coming soon.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default SettingsPage;